import * as types from "../actions";

const initialState = {
  department: [],
  loading: false,
  error: null,
  statusCode: null,
};

const Department = (state = initialState, action) => {
  switch (action.type) {
    case types.GET_DEPARTMENT_REQUEST:
      return { ...state, loading: true };
    case types.GET_DEPARTMENT_SUCCESS:
      return {
        ...state,
        loading: false,
        department: action.department,
      };
    case types.GET_DEPARTMENT_FAILED:
      return {
        ...state,
        loading: false,
        error: action.error,
        statusCode: action.statusCode,
      };
    default:
      return state;
  }
};

export default Department;
